var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgArrowExternalPink = function SvgArrowExternalPink(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 9,
    height: 9,
    fill: "none",
    viewBox: "0 0 9 9",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ffb5bf",
    d: "M7.883 1.903.933 8.849a.52.52 0 0 1-.39.15.54.54 0 0 1-.388-.157A.52.52 0 0 1 0 8.456q0-.23.155-.385l6.943-6.953H.994A.54.54 0 0 1 .596.957a.54.54 0 0 1-.16-.398.54.54 0 0 1 .16-.398A.54.54 0 0 1 .994 0h7.333q.285 0 .48.194Q9 .388 9 .674v7.335a.54.54 0 0 1-.16.398.54.54 0 0 1-.399.161.54.54 0 0 1-.398-.16.54.54 0 0 1-.16-.399z"
  })));
};
export default SvgArrowExternalPink;